var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 817.66 160.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Blue_05);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#Blue_05-10);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#Blue_05-2);\n      }\n\n      .cls-5 {\n        fill: url(#Blue_05-9);\n      }\n\n      .cls-6 {\n        fill: url(#Blue_05-6);\n      }\n\n      .cls-7 {\n        fill: url(#Blue_05-4);\n      }\n\n      .cls-8 {\n        fill: url(#Blue_05-3);\n      }\n\n      .cls-9 {\n        fill: url(#Blue_05-8);\n      }\n\n      .cls-10 {\n        fill: url(#Blue_05-5);\n      }\n\n      .cls-11 {\n        fill: url(#Blue_05-7);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05",
    "data-name": "Blue 05",
    x1: 154.08,
    y1: 141.09,
    x2: 907.58,
    y2: -256.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1736a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2643c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#435cfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#435cfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1038bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1d2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-2",
    "data-name": "Blue 05",
    x1: 163,
    y1: 157.98,
    x2: 916.5,
    y2: -239.53,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-3",
    "data-name": "Blue 05",
    x1: 174.19,
    y1: 179.2,
    x2: 927.69,
    y2: -218.31,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-4",
    "data-name": "Blue 05",
    x1: 189.83,
    y1: 208.84,
    x2: 943.33,
    y2: -188.67,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-5",
    "data-name": "Blue 05",
    x1: -165.11,
    y1: 208.48,
    x2: 302.32,
    y2: -22.51,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-6",
    "data-name": "Blue 05",
    x1: -163.59,
    y1: 211.57,
    x2: 303.84,
    y2: -19.42,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-7",
    "data-name": "Blue 05",
    x1: -177.42,
    y1: 183.58,
    x2: 290.01,
    y2: -47.41,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-8",
    "data-name": "Blue 05",
    x1: -177.42,
    y1: 183.58,
    x2: 290.01,
    y2: -47.41,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-9",
    "data-name": "Blue 05",
    x1: -172.21,
    y1: 194.13,
    x2: 295.22,
    y2: -36.87,
    xlinkHref: "#Blue_05"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blue_05-10",
    "data-name": "Blue 05",
    x1: -172.21,
    y1: 194.13,
    x2: 295.22,
    y2: -36.87,
    xlinkHref: "#Blue_05"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M276.87,116.26h-37.31v-60.22h14.32v46.33h22.99v13.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M306.32,116.26h-14.32v-60.22h14.32v60.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M363.7,116.26l-25.11-34.57v34.57h-14.32v-60.22h13.26l25.02,34.57v-34.57h14.32v60.22h-13.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M422.59,117.41c-6.13,0-11.49-1.33-16.09-3.98-4.6-2.65-8.18-6.28-10.74-10.88-2.56-4.6-3.85-9.84-3.85-15.74,0-6.31,1.29-11.85,3.89-16.62,2.59-4.77,6.19-8.5,10.79-11.19,4.6-2.68,9.93-4.02,16-4.02,6.9,0,12.63,1.49,17.2,4.46,4.57,2.98,8.03,7.27,10.39,12.86l-12.91,5.48c-3.3-5.95-8.2-8.93-14.68-8.93-4.72,0-8.58,1.59-11.58,4.77-3.01,3.19-4.51,7.58-4.51,13.18,0,3.48.68,6.51,2.03,9.11,1.36,2.59,3.24,4.6,5.66,6.01,2.42,1.41,5.19,2.12,8.31,2.12,3.54,0,6.5-.74,8.89-2.21,2.39-1.47,4.11-3.57,5.17-6.28h-15.21v-12.64h29.36c.47,2,.71,4.27.71,6.81,0,4.25-.78,8.08-2.34,11.5-1.56,3.42-3.68,6.34-6.37,8.75-2.68,2.42-5.76,4.26-9.24,5.53-3.48,1.27-7.1,1.9-10.88,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M481.66,116.26v-51.9h-18.83v-8.31h47.39v8.31h-19.72v51.9h-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M527.46,116.26v-60.22h8.84v26.61h29v-26.61h8.84v60.22h-8.84v-25.29h-29v25.29h-8.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M606.87,116.26h-8.84v-60.22h8.84v60.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M673.53,116.26l-33.95-44.04v44.04h-8.84v-60.22h7.52l33.96,44.04v-44.04h8.84v60.22h-7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M730.48,117.14c-6.07,0-11.39-1.34-15.96-4.02-4.57-2.68-8.12-6.37-10.66-11.05-2.54-4.69-3.8-9.98-3.8-15.87,0-4.48.76-8.61,2.3-12.38,1.53-3.77,3.67-7.04,6.41-9.81,2.74-2.77,5.95-4.92,9.64-6.46,3.68-1.53,7.71-2.3,12.07-2.3,6.84,0,12.44,1.4,16.8,4.2,4.36,2.8,7.93,6.56,10.7,11.27l-8.66,2.57c-2.71-3.72-5.62-6.23-8.71-7.56-3.09-1.33-6.47-1.99-10.13-1.99-4.07,0-7.71.97-10.92,2.92-3.21,1.95-5.76,4.6-7.65,7.96-1.89,3.36-2.83,7.22-2.83,11.58s.94,8.15,2.83,11.54c1.89,3.39,4.43,6.06,7.65,8s6.85,2.92,10.92,2.92c3.3,0,6.35-.63,9.15-1.9,2.8-1.27,5.19-3.01,7.16-5.22,1.97-2.21,3.37-4.79,4.2-7.74h-21.05v-8.31h29.53c.18.59.31,1.27.4,2.03s.13,1.5.13,2.21c0,3.77-.74,7.31-2.21,10.61-1.47,3.3-3.55,6.22-6.23,8.75-2.68,2.53-5.81,4.51-9.37,5.92-3.57,1.41-7.47,2.12-11.72,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M797.59,117.58c-3.12,0-6.14-.47-9.06-1.41-2.92-.94-5.59-2.49-8-4.64-2.42-2.15-4.45-5.08-6.1-8.8l7.34-4.15c2.06,3.71,4.33,6.4,6.81,8.05,2.48,1.65,5.57,2.48,9.28,2.48s6.32-.8,8.18-2.39c1.86-1.59,2.79-3.77,2.79-6.54,0-1.65-.4-3.09-1.2-4.33-.8-1.24-2.2-2.39-4.2-3.45s-4.83-2.03-8.49-2.92c-4.6-1.18-8.18-2.64-10.74-4.38s-4.35-3.74-5.35-6.01c-1-2.27-1.5-4.73-1.5-7.38,0-4.89,1.71-8.86,5.13-11.89,3.42-3.04,8.1-4.55,14.06-4.55,4.71,0,8.61.9,11.67,2.7,3.06,1.8,5.66,4.26,7.78,7.38l-7.43,4.78c-1.83-2.24-3.73-3.85-5.7-4.82-1.98-.97-4.08-1.46-6.32-1.46-3.42,0-6.03.68-7.83,2.03-1.8,1.36-2.7,3.3-2.7,5.84,0,2.18.84,4.07,2.52,5.66,1.68,1.59,4.96,2.98,9.86,4.15,4.95,1.24,8.83,2.7,11.63,4.38,2.8,1.68,4.78,3.68,5.93,6.01,1.15,2.33,1.72,5.11,1.72,8.36s-.83,6.16-2.47,8.75c-1.65,2.59-3.98,4.67-6.99,6.23s-6.54,2.34-10.61,2.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M176.68,17.54c-.82-3.68-2.88-7.63-6-10.61l-.6-.6c-.08-.08-.23-.2-.34-.28-.49-.41-1-.78-1.5-1.16-.26-.18-.54-.38-.78-.54l-.7-.41-1.41-.8c-.96-.47-1.95-.87-2.94-1.27-.96-.29-1.98-.65-2.97-.87-3.97-.96-7.88-1.13-11.64-.93-3.76.18-7.37.8-10.9,1.62-13.01,3.07-24.89,8.89-36.09,15.8-.95.59-1.9,1.19-2.83,1.78-5.9,3.86-11.59,8.09-17.01,12.62-.08.07-.16.13-.23.2-1.39,1.13-2.73,2.34-4.09,3.5-1.36,1.19-2.66,2.42-3.99,3.63-1.32,1.21-2.62,2.47-3.91,3.71l-3.89,3.92-3.51,3.74c-1.23,1.37-2.5,2.73-3.68,4.1-2.34,2.71-4.66,5.48-6.85,8.32-1.6,2.04-3.17,4.14-4.69,6.26-.52.75-1.05,1.5-1.58,2.26-2.08,2.99-4.05,6.05-5.93,9.15-1.73,2.93-3.4,5.87-4.97,8.87h4.9v13.75h-11.2c-2.13,5.46-3.82,11.06-5,16.88-.7,3.56-1.19,7.21-1.24,10.98-.07,3.76.24,7.67,1.34,11.6,1.05,3.94,3.15,7.99,6.33,11.05l.59.56.29.29.16.13s.36.33.46.41l.9.62.47.33.31.2.39.25c.52.31,1.05.62,1.57.92.56.33,1,.47,1.47.67l1.42.56c.95.29,1.88.54,2.83.75,3.74.74,7.22.62,10.44.16,3.2-.49,6.19-1.31,9.01-2.26,5.61-1.91,10.57-4.4,15.17-6.96,9.14-5.23,16.79-10.87,23.32-16.1,1.11-.88,2.17-1.75,3.22-2.6.42-.36.83-.7,1.24-1.03-.42-.29-.83-.59-1.24-.88-.41.29-.82.59-1.24.88-1.01.69-2.04,1.37-3.11,2.08-6.93,4.49-15.13,9.12-24.53,12.68-4.66,1.8-9.71,3.17-14.81,4-2.55.34-5.12.52-7.6.41s-4.84-.59-6.78-1.41c-.46-.23-.9-.47-1.34-.69l-.59-.41c-.18-.13-.44-.26-.49-.38-.1-.11-.2-.21-.31-.29l-.07-.08s-.07-.02-.15-.11l-.39-.39-.72-.75c.07.05.15.11.16.13l-.03-.08-.08-.13-.16-.28c-.9-1.41-1.41-3.11-1.5-5.23-.13-2.09.13-4.48.67-6.98.54-2.48,1.41-5.08,2.4-7.7.98-2.61,2.21-5.25,3.55-7.88,1.31-2.63,2.79-5.25,4.38-7.84,3.12-5.23,6.65-10.36,10.41-15.43.59-.77,1.16-1.55,1.75-2.3.11-.15.21-.28.33-.42,3.15-4.12,6.47-8.2,9.9-12.23,2.09-2.44,4.23-4.85,6.41-7.24l3.2-3.48,3.53-3.71,3.3-3.38,3.45-3.42c2.32-2.26,4.66-4.48,7.03-6.67,1.13-1.05,2.29-2.08,3.43-3.12,3.63-3.24,7.32-6.37,11.06-9.38,2.89-2.35,5.82-4.58,8.79-6.7,2.08-1.49,4.17-2.91,6.26-4.28,2.55-1.67,5.12-3.24,7.7-4.64,2.58-1.44,5.18-2.75,7.75-3.84,2.58-1.06,5.15-2.04,7.63-2.66,2.47-.62,4.87-.95,6.98-.92.52,0,1,.08,1.52.11.46.1.95.16,1.39.26l.64.2.34.08.16.07c.13.03.26.07.41.08.05.02.05,0,.13.03l.23.16.47.33c1.49.88,2.73,2.17,3.63,4.1.88,1.91,1.44,4.28,1.63,6.75.21,2.48.11,5.07-.15,7.63-.65,5.12-1.85,10.21-3.51,14.94-1.62,4.74-3.5,9.23-5.54,13.39-.93,1.93-1.9,3.79-2.86,5.59-1.14,2.09-2.29,4.09-3.45,5.98-3.79,6.28-7.57,11.6-10.97,15.97.11.15.21.28.31.42,3.63-4.25,7.81-9.33,12.24-15.35,1.13-1.54,2.27-3.11,3.45-4.77,1.41-1.96,2.83-4.02,4.22-6.18,2.55-3.99,5.16-8.25,7.58-12.93,2.4-4.67,4.72-9.74,6.42-15.4.83-2.86,1.55-5.83,1.93-9.07.34-3.22.34-6.72-.52-10.41ZM39.69,116.73h-8.66v-8.66h8.66v8.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M64.71,1.69c-3.53-.82-7.14-1.44-10.9-1.62-3.76-.2-7.65-.03-11.64.93-1,.21-1.99.57-2.97.87-1,.41-1.98.8-2.94,1.27l-1.42.8-.69.41c-.24.16-.52.36-.77.54-.52.38-1.03.75-1.52,1.16-.11.08-.26.2-.34.28l-.2.2-.39.41c-3.14,2.97-5.18,6.93-6.01,10.61-.85,3.69-.85,7.19-.52,10.41.38,3.24,1.09,6.21,1.93,9.07,1.7,5.65,4.02,10.72,6.42,15.4,2.42,4.67,5.03,8.94,7.58,12.93.46.7.92,1.41,1.37,2.08.95,1.41,1.9,2.78,2.84,4.1,1.16,1.67,2.32,3.24,3.45,4.77,4.43,6.01,8.61,11.1,12.23,15.35.11-.15.21-.28.33-.42-3.4-4.36-7.18-9.69-10.98-15.97-1.14-1.9-2.29-3.89-3.43-5.98-.8-1.5-1.62-3.06-2.4-4.66-.15-.31-.31-.62-.46-.93-2.04-4.15-3.91-8.65-5.54-13.39-1.65-4.72-2.84-9.82-3.51-14.94-.24-2.57-.34-5.15-.16-7.63.21-2.47.75-4.84,1.65-6.75.92-1.93,2.14-3.22,3.64-4.1l.47-.33.23-.16s.08-.02.11-.03c.15-.02.28-.05.39-.08l.2-.07.33-.08.64-.2c.46-.1.92-.16,1.39-.26.52-.03.98-.11,1.52-.11,2.11-.03,4.51.29,6.98.92,2.48.62,5.05,1.6,7.63,2.66,2.58,1.09,5.16,2.4,7.73,3.84,2.6,1.41,5.16,2.97,7.71,4.64.75.49,1.52,1,2.29,1.52.24-.23.49-.44.75-.64,5.8-4.84,11.74-9.25,17.72-13.16.28-.18.56-.36.85-.54-9.87-5.72-20.3-10.44-31.58-13.11ZM179.25,120.18c-2.84-14.22-8.94-27.21-16.26-39.5-1.01-1.68-2.06-3.35-3.14-4.98-.9-1.39-1.85-2.79-2.79-4.17-.52-.75-1.05-1.5-1.58-2.26-1.01-1.42-2.04-2.83-3.09-4.22-4.87-6.41-10.15-12.52-15.74-18.3-3.94-4.07-8.04-7.98-12.32-11.7-1.19-1.08-2.44-2.12-3.66-3.15-5.44-4.53-11.13-8.76-17.03-12.62-.95-.59-1.88-1.19-2.83-1.78-.95.59-1.9,1.19-2.83,1.78-5.9,3.86-11.59,8.09-17.01,12.62,2.96,2.12,5.88,4.36,8.78,6.7,3.74,3.01,7.44,6.15,11.06,9.38,1.18,1.05,2.34,2.11,3.5,3.17,4.71,4.33,9.33,8.86,13.81,13.52,7.04,7.31,13.76,14.92,19.97,22.75,1.01,1.26,1.99,2.53,2.97,3.81.11.15.21.28.31.42.59.75,1.18,1.54,1.75,2.3.39.51.77,1.01,1.14,1.54,3.35,4.58,6.49,9.19,9.3,13.89,1.57,2.6,3.07,5.21,4.36,7.84,1.32,2.63,2.57,5.26,3.56,7.88.98,2.62,1.85,5.21,2.39,7.7.56,2.5.8,4.89.67,6.98-.1,2.12-.62,3.82-1.49,5.23l-.16.28-.08.13-.05.08s.1-.08.21-.18l-.77.8-.39.39c-.08.1-.11.11-.13.11l-.08.08c-.11.08-.21.18-.31.29-.05.11-.31.25-.49.38l-.59.41c-.43.21-.88.46-1.34.69-1.95.82-4.3,1.29-6.77,1.41-2.48.11-5.07-.07-7.63-.41-5.1-.83-10.12-2.21-14.79-4-8.96-3.4-16.82-7.75-23.55-12.06-.34-.21-.67-.42-1-.62-1.05-.7-2.08-1.39-3.09-2.08-.42-.29-.83-.59-1.24-.88-.41.29-.82.59-1.24.88.41.33.82.67,1.24,1.03,1.05.85,2.11,1.72,3.2,2.6.16.13.33.26.51.39,6.44,5.12,13.92,10.61,22.85,15.71,4.58,2.57,9.54,5.05,15.17,6.96,2.81.95,5.77,1.77,8.99,2.26,3.22.46,6.72.57,10.46-.16.92-.21,1.86-.46,2.83-.75l1.41-.56c.47-.2.92-.34,1.47-.67.52-.29,1.06-.6,1.57-.92l.39-.25.33-.2.46-.33.9-.62.02-.03c.13-.08.46-.38.46-.38l.13-.13.31-.29.59-.56c3.17-3.06,5.28-7.11,6.33-11.05,1.11-3.94,1.41-7.84,1.34-11.6-.03-3.78-.54-7.42-1.24-10.98ZM136.64,46.75c-3.94-4.07-8.04-7.98-12.32-11.7-3.19,2.26-6.37,4.67-9.51,7.21-3.5,2.79-7.01,5.79-10.51,8.89,4.71,4.33,9.33,8.86,13.81,13.52,7.04,7.31,13.76,14.92,19.97,22.75,3.5-4.56,6.83-9.45,9.94-14.59,1.52-2.53,2.99-5.12,4.36-7.76-4.87-6.41-10.15-12.52-15.74-18.3Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "25.13 80.01 11.37 80.01 25.13 93.77 25.13 80.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "11.37 80.01 11.37 93.77 25.13 93.77 25.13 93.77 11.37 80.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "37.51 77.82 37.51 69.53 29.21 77.82 37.51 77.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "29.21 77.82 37.51 69.53 29.21 69.53 29.21 77.82"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "14.99 99.43 6.34 99.43 14.99 108.08 14.99 99.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.34 99.43 6.34 108.08 14.99 108.08 14.99 108.08 6.34 99.43"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 60.99 0 73.67 12.68 60.99 0 60.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 73.67 0 73.67 12.68 73.67 12.68 60.99 0 73.67"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3e4faf9ec0e34dcabe4b4e10c8531f9a.svg";
export { ForwardRef as ReactComponent };